var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/setup.ts
var contentServerUrl = null;
var leagueContentData = {
  init(url) {
    if (!url) {
      throw Error(
        "You must provide a url parameter when initializing leagueContentData "
      );
    }
    if (contentServerUrl) {
      console.warn(
        `leagueContentData has already been initialized with ${url}.`
      );
    }
    if (!contentServerUrl)
      contentServerUrl = url;
  },
  getContentServerUrl() {
    return contentServerUrl;
  }
};
Object.freeze(leagueContentData);

// src/upload/upload-file.ts
import Cookies from "js-cookie";
import { Auth } from "@leagueplatform/auth";
var uploadFile = (file) => __async(void 0, null, function* () {
  if (!file)
    throw new Error("File is required");
  const formData = createFormData(file);
  const uploadRequest = Auth.initialized ? yield createAuth0Request(formData) : yield createLegacyRequest(formData);
  return fetchUpload(uploadRequest);
});
var createFormData = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("name", file.name);
  return formData;
};
var createLegacyRequest = (body) => __async(void 0, null, function* () {
  const sessionId = Cookies.get("SID2");
  if (!sessionId)
    throw new Error("Authentication required");
  let contentServerUrl2 = leagueContentData.getContentServerUrl();
  const url = `${contentServerUrl2}/contentsave/${sessionId}`;
  return new Request(url, {
    method: "POST",
    body
  });
});
var createAuth0Request = (body) => __async(void 0, null, function* () {
  const accessToken = yield Auth.getToken();
  let contentServerUrl2 = leagueContentData.getContentServerUrl();
  const url = `${contentServerUrl2}/content`;
  return new Request(url, {
    method: "POST",
    body,
    headers: new Headers({
      Authorization: `Bearer ${accessToken}`
    })
  });
});
var fetchUpload = (request) => __async(void 0, null, function* () {
  const response = yield fetch(request);
  if (!response.ok) {
    throw new Error(`fetchUpload error: ${response.status}`);
  }
  const data = yield response.json();
  return data;
});

// src/utils/get-content-url.ts
var getContentUrl = (contentId) => {
  if (!leagueContentData.getContentServerUrl())
    throw Error("leagueContent has not been initialized.");
  const contentPath = `content/${contentId}`;
  return contentId ? `${leagueContentData.getContentServerUrl()}/${contentPath}` : "";
};
export {
  getContentUrl,
  leagueContentData,
  uploadFile
};
//# sourceMappingURL=index.js.map